import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { useLayoutEffect, useState, useRef, useContext, createContext } from 'react';
import scrollmonitor from 'scrollmonitor';
var attrs = ['isInViewport', 'isFullyInViewport', 'isAboveViewport', 'isBelowViewport', 'top', 'bottom', 'height'];
var defaultState = {
  isInViewport: 0,
  isFullyInViewport: 0,
  isAboveViewport: 0,
  isBelowViewport: 0,
  top: 0,
  bottom: 0,
  height: 0
};
var ScrollContainerContext = createContext(scrollmonitor);
export var useScrollMonitor = function useScrollMonitor(ref, callbacks) {
  var offsets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var current = ref.current;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      waitCount = _useState2[0],
      updateWaitCount = _useState2[1];

  var scrollMonitorContainer = useContext(ScrollContainerContext);
  var updateCheck = typeof offsets === 'number' ? [current, callbacks, scrollMonitorContainer, offsets] : [current, callbacks, scrollMonitorContainer, offsets.top, offsets.bottom];
  useLayoutEffect(function () {
    if (current === null) {
      updateWaitCount(waitCount + 1);
      return;
    }

    var watcher = scrollMonitorContainer.create(current, offsets);

    var _loop = function _loop(eventName) {
      watcher.on(eventName, function () {
        return callbacks[eventName](watcher);
      });
      watcher.update();
      watcher.triggerCallbacks();

      if (callbacks.stateChange) {
        callbacks.stateChange(watcher);
      }
    };

    for (var eventName in callbacks) {
      _loop(eventName);
    }

    return function () {
      watcher.destroy();
    };
  }, updateCheck);
  return;
};

var createUpdatedState = function createUpdatedState(watcher) {
  return attrs.reduce(function (acc, attr) {
    acc[attr] = watcher[attr];
    return acc;
  }, {});
};

export var useScrollState = function useScrollState(ref) {
  var offsets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _useState3 = useState(defaultState),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      updateState = _useState4[1];

  var _useState5 = useState({
    stateChange: function stateChange(watcher) {
      updateState(createUpdatedState(watcher));
    }
  }),
      _useState6 = _slicedToArray(_useState5, 1),
      callbacks = _useState6[0];

  useScrollMonitor(ref, callbacks, offsets);
  return state;
};

var useScrollContainer = function useScrollContainer(ref) {
  var _useState7 = useState(scrollmonitor),
      _useState8 = _slicedToArray(_useState7, 2),
      container = _useState8[0],
      setContainer = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      waitCount = _useState10[0],
      updateWaitCount = _useState10[1];

  useLayoutEffect(function () {
    if (ref.current === null) {
      updateWaitCount(waitCount + 1);
      return;
    }

    setContainer(scrollmonitor.createContainer(ref.current));
  }, [ref.current]);
  return container;
};

export var withScrollContainer = function withScrollContainer(Component) {
  return function (props) {
    var ref = useRef(null);
    var container = useScrollContainer(ref);
    return React.createElement(ScrollContainerContext.Provider, {
      value: container
    }, React.createElement(Component, _extends({
      ref: ref
    }, props)));
  };
};